/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { StartBulkDocumentDownloadBody } from '../../models/start-bulk-document-download-body';
import { StartBulkPdfDownloadDto } from '../../models/start-bulk-pdf-download-dto';

export interface StartBulkPdfDownload$Params {
  body: StartBulkDocumentDownloadBody;
}

export function startBulkPdfDownload(
  http: HttpClient,
  rootUrl: string,
  params: StartBulkPdfDownload$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<StartBulkPdfDownloadDto>> {
  const rb = new RequestBuilder(rootUrl, startBulkPdfDownload.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StartBulkPdfDownloadDto>;
      }),
    );
}

startBulkPdfDownload.PATH = '/document/download';
